import { useState,useEffect,useCallback } from 'react'
import {
AlertDialog,
AlertDialogContent,
AlertDialogHeader,
AlertDialogTitle,
AlertDialogDescription,
AlertDialogFooter,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'

export function SessionExpiredDialog() {
  const [open, setOpen] = useState(false)

  const handleExpired = useCallback(() => {
    setOpen(true)
  }, [])

  useEffect(() => {
    window.addEventListener('rp:session-expired', handleExpired)
    return () => window.removeEventListener('rp:session-expired', handleExpired)
  }, [handleExpired])

  const handleGoToLogin = () => {
    window.location.href = '/'
  }

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="sm:max-w-sm" onEscapeKeyDown={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Session Expired</AlertDialogTitle>
          <AlertDialogDescription>
            Your session has expired. Please log in again to continue.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button onClick={handleGoToLogin}>
            Go to Login
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
